module.exports = __webpack_public_path__ + "img/dc98a0b.png";